import { QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode, useState } from 'react';

import { createQueryClient } from './query-client';

/**
 * Wraps the app in a single QueryClient. `useState` keeps one client per mount
 * (a fresh one per SSR render, stable across client re-renders), so server and
 * browser never share cache state.
 */
export function QueryProvider({
	children,
	onError,
}: {
	children: ReactNode;
	onError?: (error: unknown) => void;
}) {
	const [client] = useState(() => createQueryClient(onError));
	return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
